export const REFRESH_FILE_CATEGORIES = 'REFRESH_FILE_CATEGORIES'

export const setRefreshFileCategory = (done) => {
  return {
    type: REFRESH_FILE_CATEGORIES,
    done
  }
}
